import axios from "axios";
import { useEffect, useState } from "react";
import NavBar from "../../navbar/NavBar";
import { useDispatch } from "react-redux";
import { Dayjs } from "dayjs";
import {
	closeLoader,
	openLoader,
} from "../../../redux/actions/loader/loaderActions";
import { openToastAndSetContent } from "../../../redux/actions/toast/toastActions";
import {
	PaymentMethodModuleData,
	ColumnPaymentMethodModule,
} from "../../../types/PaymentMethodTypes";
import TableHeader from "../../TableHeader/TableHeader";
import PaginationTable from "../../paginatedTable/pagination-table";
import { Box } from "@mui/material";
import { InputLabel, TextField } from "@material-ui/core";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import styles from "./PaymentMethod.module.scss";
import {
	closeModal,
	openModalAndSetContent,
} from "../../../redux/actions/modal/modalActions";
// import useDownload from "../../../interfaces/Download";
import StatusView from "../../StatusView/StatusView";
import FilterModal from "../../filterConfig/FilterModal";
import { useHistory, useParams } from "react-router-dom";
import { formatTime } from "../../../util/timeUtils";

const PaymentMethodTable = () => {
	const { id } = useParams<any>();

	const [contentAction, setContentAction] = useState<any>({});
	const history = useHistory();
	const [paymentMethod, setPaymentMethod] = useState<any>();
	const [edit, setEdit] = useState(false);

	// pagination
	const [pageNumber, setPageNumber] = useState<number>(1);
	const [rowsPerPage, setRowsPerPage] = useState<number>(10);
	const [tableRow, setTableRow] = useState<any[]>();
	const [nextPage, setNextPage] = useState<number | null>(null);
	const [previousPage, setPreviousPage] = useState<number | null>(null);

	// filters
	const [eventDate, setEventDate] = useState("");
	const [fromDate, setFromDate] = useState<Dayjs | null | string>("");
	const [toDate, setToDate] = useState<Dayjs | null | string>("");
	const [status, setStatus] = useState(false);
	const [value, setValue] = useState("");
	const [merchantId, setMerchantId] = useState("");
	const [bearer, setBearer] = useState<boolean>(false);
	const [dropdown, setDropdown] = useState(false);

	// hooks
	const dispatch = useDispatch();

	const label = { inputProps: { "aria-label": "Size switch demo" } };

	const GreenSwitch = styled((props: SwitchProps) => (
		<Switch
			focusVisibleClassName=".Mui-focusVisible"
			disableRipple
			{...props}
		/>
	))(({ theme }) => ({
		width: 42,
		height: 26,
		padding: 0,
		"& .MuiSwitch-switchBase": {
			padding: 0,
			margin: 2,
			transitionDuration: "300ms",
			"&.Mui-checked": {
				transform: "translateX(16px)",
				color: "#fff",
				"& + .MuiSwitch-track": {
					backgroundColor:
						theme.palette.mode === "dark" ? "#27ae60" : "#65C466",
					opacity: 1,
					border: 0,
				},
				"&.Mui-disabled + .MuiSwitch-track": {
					opacity: 0.5,
				},
			},
			"&.Mui-focusVisible .MuiSwitch-thumb": {
				color: "#33cf4d",
				border: "6px solid #fff",
			},
			"&.Mui-disabled .MuiSwitch-thumb": {
				color:
					theme.palette.mode === "light"
						? theme.palette.grey[100]
						: theme.palette.grey[600],
			},
			"&.Mui-disabled + .MuiSwitch-track": {
				opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
			},
		},
		"& .MuiSwitch-thumb": {
			boxSizing: "border-box",
			width: 22,
			height: 22,
		},
		"& .MuiSwitch-track": {
			borderRadius: 26 / 2,
			backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
			opacity: 1,
			transition: theme.transitions.create(["background-color"], {
				duration: 500,
			}),
		},
	}));

	const BoxComponent = ({ identifier }: any) => {
		const [otp, setOtp] = useState<any>("");
		const [buttonEdit, setButtonEdit] = useState(false);
		const [buttonStatus, setButtonStatus] = useState(false);

		const toggleEdit = (value: boolean) => {
			setButtonEdit(value);
		};

		const toggleStatus = (value: boolean) => {
			setButtonStatus(value);
		};

		const handleChange = async (
			id: number,
			paymentmethod: string,
			merchantId: number,
			otp: number
		) => {
			dispatch(openLoader());

			const newObject = {
				methods: [
					{
						id,
						paymentmethod,
						status: buttonStatus,
						iseditable: buttonEdit,
					},
				],
				otp: otp,
			};

			try {
				const response: any = await axios.post(
					`/v1/business/${merchantId}/paymentMethod/modify`,
					newObject
				);

				if (response?.data) {
					getPaymentMethods();

					dispatch(
						openToastAndSetContent({
							toastContent: response?.data?.message,
							toastType: "success",
						})
					);
					dispatch(closeLoader());
					dispatch(closeModal());
				}
			} catch (err: any) {
				dispatch(closeLoader());
				dispatch(
					openToastAndSetContent({
						toastContent: err?.response?.data?.message,
						toastType: "error",
					})
				);
			}
		};

		useEffect(() => {
			setStatus(identifier.status);
			setButtonEdit(identifier.iseditable);
		}, []);

		return (
			<div className={styles.outerboxModal}>
				<div className={styles.innerboxModal}>
					<div className={styles.editStatus}>Payment Status:</div>
					<p>
						<GreenSwitch
							value={buttonStatus}
							defaultChecked={identifier.status}
							name="status"
							{...label}
							size="small"
							onChange={(e) => toggleStatus(e.target.checked)}
						/>
					</p>
				</div>
				<div
					className={styles.innerboxModal}
					style={{
						marginTop: "20px",
					}}
				>
					<div className={styles.editStatus}>Make Editable:</div>
					<p>
						<GreenSwitch
							value={buttonEdit}
							defaultChecked={identifier.iseditable}
							name="edit"
							{...label}
							size="small"
							onChange={(e) => toggleEdit(e.target.checked)}
						/>
					</p>
				</div>
				<div style={{ marginTop: "20px" }}>
					<TextField
						style={{ width: "100%" }}
						id="outlined-basic"
						label="Otp"
						variant="outlined"
						placeholder="Enter your otp"
						onChange={(e) => setOtp(e.target.value)}
					/>
					<InputLabel>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								paddingTop: "10px",
							}}
						>
							<InfoRoundedIcon />
							<p className={styles.info}>
								If you have not set up your 2FA, kindly{" "}
								<a style={{ color: "blue" }} href={`/account`} target="_blank">
									click here
								</a>
							</p>
						</div>
					</InputLabel>
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						marginTop: "30px",
						alignItems: "center",
						flexDirection: "row",
					}}
				>
					<button
						onClick={() => dispatch(closeModal())}
						className={styles.modalButtonClose}
					>
						Cancel
					</button>

					<button
						onClick={() =>
							handleChange(
								identifier.merchantaccountmethodid,
								identifier.paymentmethod,
								identifier.merchantaccountid,
								otp
							)
						}
						className={styles.modalButton}
					>
						Save changes
					</button>
				</div>
			</div>
		);
	};

	const editConfigHandler = (identifier: any) => {
		dispatch(
			openModalAndSetContent({
				modalStyles: {
					padding: 0,
				},
				modalContent: (
					<div className={styles.modalDiv}>
						<BoxComponent identifier={identifier} />
					</div>
				),
			})
		);
	};

	// function to get data
	const getPaymentMethods = async () => {
		dispatch(openLoader());
		try {
			const data = await axios.get(`/v1/business/${id}/paymentMethod`);
			setPaymentMethod(data?.data);
			dispatch(closeLoader());
			setBearer(false);
		} catch (err: any) {
			dispatch(closeLoader());
			dispatch(
				dispatch(
					openToastAndSetContent({
						toastContent:
							err?.response?.data?.message ||
							err?.data?.message ||
							err?.message ||
							err,
						toastType: "error",
					})
				)
			);
		}
	};

	//trigger data fetching on dependency change
	useEffect(() => {
		getPaymentMethods();
	}, [bearer, rowsPerPage]);
	// set pagination
	useEffect(() => {
		setPageNumber(paymentMethod?._metadata?.page || 1);
	}, [paymentMethod]);

	// transform data

	const dataReserve = () => {
		const tempArr: PaymentMethodModuleData[] = [];
		paymentMethod?.paymentMethods
			?.slice(0)
			.reverse()
			.forEach((paymtd: any, index: number) => {
				return tempArr.push({
					paymentmethod: paymtd?.paymentmethod || "N/A",
					currency: paymtd?.currency || "N/A",
					createdat: formatTime(paymtd?.createdat) || "N/A",
					status: (
						<StatusView
							status={paymtd?.status === true ? "true" : "false"}
							orange="false"
							green="true"
						/>
					),
					// paymtd?.iseditable &&
					iseditable: (
						<button
							style={{
								border: 0,
								borderRadius: "10px",
								padding: "4px 12px",
								backgroundColor: "#FFD2D2",
								fontFamily: "Avenir",
								fontStyle: "normal",
								fontWeight: 500,
								fontSize: "12px",
								minHeight: "28px",
								cursor: "pointer",
							}}
							onClick={() => editConfigHandler(paymtd)}
						>
							Edit
						</button>
					),
				});
			});
		return tempArr;
	};
	// set data to table row
	useEffect(() => {
		setTableRow(dataReserve());
	}, [paymentMethod?.paymentMethods]);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				backgroundColor: "#eff3f8",
				height: "100%",
			}}
		>
			<NavBar name="Payment Methods" />
			<Box
				sx={{
					marginTop: "2rem",
					padding: "2rem",
				}}
			>
				<TableHeader
					// pageName="Payment method table"
					data={paymentMethod?.paymentMethods}
					// dataLength={paymentMethod?._metadata.totalcount}
					value={value}
					setValue={setValue}
					dropdown={dropdown}
					setDropdown={setDropdown}
					placeHolder="Search"
					exporting={false}
					filtering={false}
					// handleClick={handleDownload}
					// FilterComponent={
					// 	<FilterModal
					// 		eventDate={eventDate}
					// 		setEventDate={setEventDate}
					// 		dropdown={dropdown}
					// 		setDropdown={setDropdown}
					// 		setFromDate={setFromDate}
					// 		setToDate={setToDate}
					// 		fromDate={fromDate}
					// 		toDate={toDate}
					// 		setBearer={setBearer}
					// 		// clearHandler={clearHandler}
					// 		// filteredArray={filteredArray}
					// 	/>
					// }
				/>

				<Box sx={{ overflowX: "auto" }}>
					<PaginationTable
						data={tableRow ? tableRow : []}
						columns={ColumnPaymentMethodModule ? ColumnPaymentMethodModule : []}
						// emptyPlaceHolder={
						// 	paymentMethod?.paymentMethods?.length === 0
						// 		? "No record found"
						// 		: "Loading..."
						// }
						value={value}
						// total={paymentMethod?._metadata.totalcount}
						// totalPage={paymentMethod?._metadata.pagecount}
						pageNumber={pageNumber}
						setPageNumber={setPageNumber}
						nextPage={nextPage}
						setBearer={setBearer}
						setNextPage={setNextPage}
						previousPage={previousPage}
						setPreviousPage={setPreviousPage}
						rowsPerPage={rowsPerPage}
						setRowsPerPage={setRowsPerPage}
						clickAction={true}
						setContentAction={setContentAction}
					/>
				</Box>
			</Box>
		</div>
	);
};

export default PaymentMethodTable;
